import React from 'react';
import { Space } from 'antd';

import { DefaultQuestion } from '../DefaultQuestion';
import { WorkloadSection } from '../WorkloadSection';
import { SurveySection, SurveyContentProps } from '../types';

export function SurveyContent({
	workloadQuestions,
	currentQuestions,
	currentSection,
	saveAnswer,
	isMobile
}: SurveyContentProps) {
	if (currentSection === SurveySection.WORKLOAD) {
		if (isMobile) {
			return <WorkloadSection workloadQuestions={currentQuestions} saveAnswer={saveAnswer} />;
		}
		return <WorkloadSection workloadQuestions={workloadQuestions} saveAnswer={saveAnswer} />;
	}

	return (
		<Space direction="vertical" style={{ width: '100%' }}>
			{currentQuestions.map((question, index) => (
				<DefaultQuestion
					isMobile={isMobile}
					key={question.id}
					question={question}
					index={index}
					saveAnswer={saveAnswer}
				/>
			))}
		</Space>
	);
}
